import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Footer from 'components/Footer/Footer';
import './style.css';
import creativeGames from 'Assets/creativeGames.png';
import StaticBanner from 'components/Banner/StaticBanner';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import Sponsor from "components/Sponsors/Sponsor";
// import kohler from "Assets/kohlerlogo.svg";
// import lego from "Assets/legol.svg";
// import spiral from "Assets/spiral.svg";
// import dentsu from "Assets/dentsulogo.svg";
// import vmware from "Assets/vmware.svg";
import { ReactTypeformEmbed } from 'react-typeform-embed';
import home from 'Assets/home.svg';

export default class CreativeGames extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <>
            <Helmet>
                <title>Creative Games 2020 - PechaKucha Tokyo</title>
            </Helmet>
            <div>
                {/* Banner Starts */}
                <StaticBanner
                    typeForm="#typeForm"
                    bannerImg={creativeGames}
                    btnText="Get More Info"
                    upcomingGames="*Now Announcing* The 2020 Creative Games"
                    presentedBy="Presented by PechaKucha and Spiral"
                    dateOfPresentation="Tokyo, August 15 -  22, 2020"
                />
                {/* Banner Section ends */}
                {/* About Section Starts */}
                <div className="creativeGames">
                    <div className="container">
                        <h3>
                        The Inaugural <span>2020 Creative Games in Tokyo</span> will take place for eight days (August 15 - 22, 2020), in the days between the XXXII Tokyo Summer Olympics and the XVI Paralympic Games. This is a celebration of all the 2020 games and honors the birthplace of PechaKucha - which has since exploded worldwide. Spiral, our partner and one of Japan's leading art foundations, is hosting the Creative Games in its exquisite building in the heart of Tokyo in Omotesando. Check back for more info in the coming weeks. Let’s unite and celebrate our PK worlds!
                        </h3>
                        {/*
                        <h3><span>The 2020 Creative Games in Tokyo -</span> which will take place for <span>8 days
                            (15th - 22nd August 2020)</span> between the Tokyo Olympic and Paralympic Games. Not only is it a celebration
                            of 2020 and the games in Tokyo but the fact that PechaKucha started in Tokyo and has spread worldwide. We thought
                            it was time to unite the network at the amazing moment. We have teamed up with Spiral, one of Japan's leading
                            art foundations and will be using their amazing building in the heart of Tokyo in Omotesando. We'll provide more
                            details in the coming weeks.
                        </h3>
                        */}
                    </div>
                </div>
                {/* About Section Ends */}
                {/* Form Section */}
                <section id="getMoreInfo">
                    <div className="container">
                        <Row>
                            <Col lg={12}>
                                <div className="form-head">
                                    <h1>Sign-up to get more information</h1>
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <div className="school-formdetails" id="typeForm">
                                        <ReactTypeformEmbed url="https://pechakucha.typeform.com/to/HEIYeu" />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
                {/* Form Section Ends */}
                {/* Thanks to your Sponsor Section Starts */}
                {/*
                <Sponsor sponsorHeading="Thanks to our sponsors!" sponsorLogoOne={kohler} sponsorLogoTwo={lego}
                    sponsorLogoThree={spiral} sponsorLogoFourth={vmware} sponsorLogoFive={dentsu} logoStatus={true} />
                */}
                {/* Thanks to your Sponser Section Ends */}
                <Footer
                    homeImg={home}
                    homeImgRef="/"
                    breadcrumbSubPage="Creative Games" />
            </div>
            </>
        );
    }
}